// extracted by mini-css-extract-plugin
export default {"container":"ColorectalCancerScreening_container__e+c9S","back-btn":"ColorectalCancerScreening_back-btn__ig0bD","back-icon":"ColorectalCancerScreening_back-icon__G77E0"};